import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-premium';
import { baseCell, DataGridCell } from 'components/cells';
import { filterOperators } from 'components/enhanced';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export function useCategoriesColumns(detailNav = false): GridColDef[] {
  const { t } = useTranslation();
  return [
    {
      field: 'code',
      headerName: t(`global.code`),
      width: 150,
      filterOperators,
      renderCell: (params: GridRenderCellParams) => {
        const category = params.row;
        return detailNav ? (
          <div>
            <Link to={`${category.id}`}>
              <b className="text-secondary-500">{category.code}</b>
            </Link>
          </div>
        ) : (
          <DataGridCell content={params.value as string} />
        );
      }
    },
    {
      field: 'description',
      headerName: t(`global.description`),
      filterOperators,
      editable: detailNav,
      width: 500,
      renderCell: baseCell
    },
    {
      field: 'sector',
      headerName: t(`global.sector`),
      filterOperators,
      width: 150,
      flex: 1,
      renderCell: baseCell
    }
  ];
}
